/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_DescriptionInputs */



/**
* | output |
* | --- |
* | "oneAI Relays are customer-deployed daemons that reach into your internal network on the cloud's behalf, for LDAP and SMB shares. Issue an API key here, then ..." |
*
* @param {Agents_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_description = /** @type {((inputs?: Agents_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI-Relays sind vom Kunden bereitgestellte Dienste, die im Auftrag der Cloud auf Ihr internes Netzwerk zugreifen, etwa für LDAP und SMB-Freigaben. Erstellen Sie hier einen API-Schlüssel und starten Sie oneai-agent damit.")
	return /** @type {LocalizedString} */ ("oneAI Relays are customer-deployed daemons that reach into your internal network on the cloud's behalf, for LDAP and SMB shares. Issue an API key here, then run oneai-agent with that key.")
});